import React from "react";
import LoginView from "./Views/LoginView";
import { observer } from "mobx-react-lite";
import { signInWithPopup, GoogleAuthProvider, getAuth, signOut } from "firebase/auth";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const auth = getAuth();
const provider = new GoogleAuthProvider();


const LoginPresenter = observer(({ model }) => {

    function handleGoogleLogin() {
        signInWithPopup(auth, provider)
            .then((result) => {
                console.log("User signed in:", result.user);
                toast.success(`Welcome, ${result.user.displayName}! 🎉`, {
                    position: "top-right",
                    autoClose: 3000,
                });
                model.setIsLoggedIn(true);
                console.log(model.isLoggedIn);
            })
            .catch((error) => {
                console.error("Error during Google Sign-In:", error.message);
                toast.error("Login failed. Please try again.", {
                    position: "top-right",
                    autoClose: 3000,
                });
            });
    }

    function handleLogout() {
      signOut(auth)
        .then(() => {
          toast.success("You have been logged out successfully.", {
            position: "top-right",
            autoClose: 3000,
          });
          model.setIsLoggedIn(false);
        })
        .catch((error) => {
          console.error("Error during logout:", error.message);
          toast.error("Logout failed. Please try again.", {
            position: "top-right",
            autoClose: 3000,
          });
        });
    }

    

    return (
        <>
            <LoginView handleGoogleLogin={handleGoogleLogin} handleLogout={handleLogout} isLoggedIn={model.isLoggedIn} />
            <ToastContainer />
        </>
    );
});

export default LoginPresenter;
